import { BaseApi } from '@shared/config';
import type {
  GetEmploymentTypesRequest,
  GetEmploymentTypesResponse,
} from './types';

class EmploymentTypeApi extends BaseApi {
  getEmploymentTypes = (
    params: GetEmploymentTypesRequest
  ): Promise<GetEmploymentTypesResponse> => {
    return this.instance.get('/employment-types', { params });
  };
}

export const employmentTypeApi = new EmploymentTypeApi();
